export default __webpack_public_path__ + "static/media/POLLO.610a1c91.png";